export default __webpack_public_path__ + "static/media/story.f140d693.mp4";